<template>
  <div>
    <!-- Hidden buttons -->
    <button
      style="display: none"
      type="button"
      class="btn-show-modal-select-pay-now-payment-method"
      data-bs-toggle="modal"
      data-bs-target="#modalSelectPayNowPaymentMethod"
    ></button>

    <button
      style="display: none"
      type="button"
      class="btn-hide-modal-select-pay-now-payment-method"
      data-bs-dismiss="modal"
      data-bs-target="#modalSelectPayNowPaymentMethod"
    ></button>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modalSelectPayNowPaymentMethod"
      tabindex="-1"
      aria-labelledby="modalSelectPayNowPaymentMethodLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <KskModalShell :width="680" :show-close="false">
        <div class="ksk-qrapp">
          <div class="ksk-qrapp__head">
            <h2 id="modalSelectPayNowPaymentMethodLabel" class="ksk-qrapp__title">{{ $t("kiosk.paynowApp.title") }}</h2>
            <button
              type="button"
              class="btn-close-modal ksk-qrapp__close"
              :aria-label="$t('kiosk.common.close')"
              data-bs-dismiss="modal"
            >
              <span class="material-icons-round">close</span>
            </button>
          </div>

          <div class="ksk-qrapp__list" role="radiogroup">
            <button
              v-for="method in methods"
              :key="method.id"
              type="button"
              role="radio"
              :aria-checked="selectedMethod === method.id"
              class="ksk-qrapp__card"
              :class="{ 'ksk-qrapp__card--selected': selectedMethod === method.id }"
              @click="selectMethod(method.id)"
            >
              <span class="ksk-qrapp__logo">
                <img :src="method.icon" alt="" />
              </span>
              <span class="ksk-qrapp__info">
                <span class="ksk-qrapp__name">{{ method.name }}</span>
                <span class="ksk-qrapp__desc">{{ $t(method.descKey) }}</span>
              </span>
              <span class="ksk-qrapp__radio">
                <span class="material-icons-round">check</span>
              </span>
            </button>
          </div>

          <KskButton
            block
            size="md"
            class="ksk-qrapp__pay"
            icon="qr_code_2"
            :disabled="!selectedMethod"
            @click="paynowQR"
          >{{ buttonText }}</KskButton>
        </div>
      </KskModalShell>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import KskModalShell from "./ui/KskModalShell.vue";
import KskButton from "./ui/KskButton.vue";

export default {
  name: "ModalSelectPayNowPaymentMethod",
  components: {
    KskModalShell,
    KskButton,
  },

  props: {
    keyReload: {
      required: true,
    },
  },

  data() {
    return {
      selectedMethod: 1,

      methods: [
        {
          id: 1,
          name: "PayNow",
          descKey: "kiosk.paynowApp.paynowDesc",
          icon: require(`@/assets/paynow_qr.png`),
        },
        {
          id: 2,
          name: "Alipay",
          descKey: "kiosk.paynowApp.alipayDesc",
          icon: require(`@/assets/alipay_qr.png`),
        },
        {
          id: 3,
          name: "WeChat Pay",
          descKey: "kiosk.paynowApp.wechatDesc",
          icon: require(`@/assets/wechat_qr.png`),
        },
      ],
    };
  },

  computed: {
    buttonText() {
      const method = this.methods.find((m) => m.id === this.selectedMethod);
      return method
        ? this.$t("kiosk.paynowApp.payWith", { name: method.name })
        : this.$t("kiosk.paynowApp.select");
    },
  },

  methods: {
    selectMethod(id) {
      this.selectedMethod = id;
    },

    paynowQR() {
      $('.btn-hide-modal-select-pay-now-payment-method').click();
      this.$emit('paynow-qr', this.selectedMethod);
    },
  },
  
  watch: {
    keyReload() {
      this.selectedMethod = 1;
    },
  },
};
</script>

<style scoped>
/* KSK030 — P13 PayNow / Alipay / WeChat chooser (theme 2). Sized like the
   other kiosk dialogs: 680px, 40px padding, 32px title, 80px button. */
.modal {
  overflow-y: hidden !important;
}
.modal :deep(.ksk-modal) {
  padding: 40px;
}

.ksk-qrapp__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ksk-space-2);
}
.ksk-qrapp__title {
  margin: 0;
  font-family: var(--ksk-font);
  font-size: var(--ksk-title-size);
  line-height: var(--ksk-title-lh);
  font-weight: 700;
  color: var(--ksk-text);
}
.ksk-qrapp__close {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin: -8px -8px -8px 0;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: var(--ksk-surface-muted);
  color: var(--ksk-text);
  cursor: pointer;
}
.ksk-qrapp__close .material-icons-round {
  font-size: 30px;
}

.ksk-qrapp__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: var(--ksk-space-3) 0;
}
.ksk-qrapp__card {
  display: flex;
  align-items: center;
  gap: var(--ksk-space-2);
  width: 100%;
  height: 96px;
  padding: 0 20px;
  border: 2px solid var(--ksk-border);
  border-radius: var(--ksk-radius-card);
  background: var(--ksk-surface);
  font-family: var(--ksk-font);
  text-align: left;
  cursor: pointer;
  transition: border-color 80ms ease-out, background-color 80ms ease-out;
  -webkit-tap-highlight-color: transparent;
}
.ksk-qrapp__card:active {
  transform: scale(0.99);
}
.ksk-qrapp__card--selected {
  border-color: var(--ksk-primary);
  background: var(--ksk-primary-container);
}
.ksk-qrapp__logo {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: var(--ksk-shadow-card);
  overflow: hidden;
}
.ksk-qrapp__logo img {
  width: 46px;
  height: 46px;
  object-fit: contain;
}
.ksk-qrapp__info {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.ksk-qrapp__name {
  font-size: var(--ksk-item-size);
  line-height: var(--ksk-item-lh);
  font-weight: 700;
  color: var(--ksk-text);
}
.ksk-qrapp__desc {
  font-size: 18px;
  line-height: 24px;
  color: var(--ksk-text-secondary);
}
.ksk-qrapp__radio {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 2px solid var(--ksk-border);
  border-radius: 50%;
  background: var(--ksk-surface);
  color: transparent;
}
.ksk-qrapp__radio .material-icons-round {
  font-size: 26px;
}
.ksk-qrapp__card--selected .ksk-qrapp__radio {
  border-color: var(--ksk-primary);
  background: var(--ksk-primary);
  color: var(--ksk-on-primary);
}
</style>
